"use client";

import { useSessionAutoIndex } from "@/hooks/useSessionAutoIndex";

export function SessionAutoIndex() {
  useSessionAutoIndex();
  return null;
}
